import { Link } from "react-router-dom";
import {
  FaBookOpen,
  FaClock,
  FaCheckCircle,
  FaChalkboardTeacher,
} from "react-icons/fa";
import OCJouney from '../../assets/ninja.png'

const iconColorMap = {
  FaBookOpen: "text-purple-500",
  FaClock: "text-orange-500",
  FaCheckCircle: "text-green-500",
  FaChalkboardTeacher: "text-purple-500",
};

const benefits = [
  {
    subtitle: "Practice Questions",
    title: "Unlimited Practice",
    description: "Untimed practice questions in Reading, Mathematical Reasoning and Thinking Skills. Unlimited re-sits to practice each test as many times as you like.",
    points: [
      { icon: <FaBookOpen className={iconColorMap["FaBookOpen"]} />, text: "Practice questions are aligned to the New South Wales (NSW) curriculum." },
      { icon: <FaCheckCircle className={iconColorMap["FaCheckCircle"]} />, text: "Ability for children to achieve Black Belt in Maths." },
    ],
    color: "from-orange-500 to-yellow-400",
    shadow: "shadow-orange-300",
    badge: "bg-yellow-100 text-yellow-700",
  },
  {
    subtitle: "Mock Tests",
    title: "Real Exam Practice",
    description: "Mock tests build familiarity with the online assessment format. Mock tests for OC and Selective ensure children build focus and confidence for exam day.",
    points: [
      { icon: <FaClock className={iconColorMap["FaClock"]} />, text: "Timed tests for Reading, Mathematical Reasoning, Thinking Skills, and Creative Writing." },
      { icon: <FaCheckCircle className={iconColorMap["FaCheckCircle"]} />, text: "Immediate results and actionable progress reports." },
    ],
    color: "from-green-500 to-blue-400",
    shadow: "shadow-green-300",
    badge: "bg-green-100 text-green-700",
  },
  {
    subtitle: "Online Lessons",
    title: "Personalized Support",
    description: "Assisting in explaining the concept of a specific topic online thereby ensuring that we are closing any gaps as we find them.",
    points: [
      { icon: <FaChalkboardTeacher className={iconColorMap["FaChalkboardTeacher"]} />, text: "Personalized topic explanations online." },
      { icon: <FaCheckCircle className={iconColorMap["FaCheckCircle"]} />, text: "Addressing gaps in knowledge as they arise." },
    ],
    color: "from-purple-500 to-teal-400",
    shadow: "shadow-purple-300",
    badge: "bg-purple-100 text-purple-700",
  },
];

export default function Benefits() {
  return (
    <div className="bg-blue-50 min-h-screen py-10 sm:py-20 px-4 sm:px-6 md:px-10">
      <h2 className="text-center text-3xl sm:text-4xl md:text-5xl font-extrabold text-purple-800">
        Opportunity Class(OC) Journey
      </h2>

      <p className="text-base sm:text-lg md:text-xl text-gray-700 px-4 sm:pl-6 sm:pr-4 md:pl-16 md:pr-10 mt-6 sm:mt-10 mb-2">
        Is your child in <span className="font-bold text-teal-600">Year 3 or 4</span> and aiming to succeed in the <span className="font-bold text-yellow-500">Opportunity Class (OC) Exam</span>? You've come to the right place.
        <br /><br />
        Whether you’re just starting the <span className="font-bold text-yellow-500">OC journey</span> in <span className="font-bold text-teal-600">Year 3</span> or already deep into preparation in <span className="font-bold text-teal-600">Year 4</span>, our program is designed to give your child the edge they need. With a powerful mix of targeted practice questions and realistic mock tests, we help build the confidence, speed, and accuracy required for success.
        <br /><br />
        We take the guesswork out of <span className="font-bold text-yellow-500">OC preparation</span> so you can focus on supporting your child, and they can focus on reaching their potential.
        <br /><br />
        <span className="block italic font-semibold text-purple-700 text-center">
          Let’s start this journey together.
        </span>

      </p>


      <div className="bg-blue-50 pt-8 sm:pt-14 pb-6 sm:pb-8 px-4 sm:px-6 md:px-10">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 md:gap-x-20 gap-6 sm:gap-8 md:gap-y-12 items-start">

          {/* Left Side - Only Image */}
          <div className="flex justify-center items-start order-2 md:order-2 mt-6 md:mt-10">
            <img
              src={OCJouney}
              alt="Journey Visual"
              className="w-full rounded-xl sm:rounded-2xl md:rounded-3xl shadow-lg sm:shadow-xl md:shadow-2xl object-contain"
              style={{ maxWidth: '100%', maxHeight: '100vh' }}
            />
          </div>

          {/* Right Side - Heading + All Cards stacked */}
          <div className="space-y-4 sm:space-y-6 md:space-y-7 max-w-2xl order-1 md:order-1">

            {/* Card 1 - Practice Questions */}
            <div className="p-4 sm:p-5 md:p-6 rounded-xl sm:rounded-2xl bg-gradient-to-r from-yellow-100 via-yellow-50 to-yellow-100 shadow-md sm:shadow-lg border-l-4 sm:border-l-6 md:border-l-8 border-yellow-400 space-y-2 sm:space-y-3">
              <h4 className="text-xl sm:text-2xl font-semibold text-yellow-700">Practice Questions</h4>
              <p className="text-sm sm:text-base text-gray-800">
                The goal of our practice questions is to build a strong foundation so your child feels confident and prepared for each mock test. Watch them progress step by step—from White Belt to Black Belt in Maths—as they master key concepts and sharpen their problem-solving skills along the way.
              </p>
              <ul className="list-disc pl-4 sm:pl-5 text-gray-700 text-xs sm:text-sm space-y-1">
                <li>
                  <Link to="/login" className="hover:text-blue-600 hover:underline cursor-pointer">
                    Maths – <span className="font-bold text-green-600">$109</span>
                  </Link>
                </li>
                <li>Reading – <span className="italic text-gray-500">Coming soon</span></li>
                <li>Thinking Skills – <span className="italic text-gray-500">Coming soon</span></li>
              </ul>
            </div>

            {/* Card 2 - Weekly Mock Tests */}
            <div className="p-4 sm:p-5 md:p-6 rounded-xl sm:rounded-2xl bg-gradient-to-r from-green-100 via-green-50 to-green-100 shadow-md sm:shadow-lg border-l-4 sm:border-l-6 md:border-l-8 border-green-400 space-y-2 sm:space-y-3">
              <h4 className="text-xl sm:text-2xl font-semibold text-green-700">Weekly Mock Tests</h4>
              <p className="text-sm sm:text-base text-gray-800">
                Designed to simulate real exam conditions including Reading, Mathematical Reasoning, and Thinking Skills.
              </p>
              <ul className="list-disc pl-4 sm:pl-5 text-gray-700 text-xs sm:text-sm space-y-1">
                <li>
                  <Link to="/login" className="hover:text-blue-600 hover:underline cursor-pointer">
                    Math's mock test: – <span className="font-bold text-green-600">$95</span>
                  </Link>
                </li>
                <li>Bundle of 10:  <span className="font-bold text-green-600">$400</span> – <span className="italic text-gray-500">Coming soon</span></li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      <div className="mt-6 text-center">
        <div className="flex justify-center gap-9 flex-wrap">
          <Link to="/exam-selection">
            <button className="bg-yellow-400 hover:bg-orange-500 text-white font-semibold text-base sm:text-lg px-6 sm:px-8 md:px-10 py-2 sm:py-3 md:py-4 rounded-full shadow-md sm:shadow-lg transition duration-300">
              Start Assessment
              <i className="fas fa-arrow-right ml-2"></i>
            </button>
          </Link>

          <Link to="/signup">
            <button className="bg-purple-600 hover:bg-teal-600 text-white font-semibold text-base sm:text-lg px-6 sm:px-8 md:px-10 py-2 sm:py-3 md:py-4 rounded-full shadow-md sm:shadow-lg transition duration-300">
              Sign Up
              <i className="fas fa-arrow-right ml-2"></i>
            </button>
          </Link>
        </div>
      </div>

    </div>
    //   // <div className="bg-blue-50 min-h-screen py-10 sm:py-20 px-4 sm:px-6 md:px-10">
    //     /* <h2 className="text-center text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-800 mb-8 sm:mb-16">
    //       Benefits of Examwarrior Community
    //     </h2>

    //     <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 md:gap-10">
    //       {benefits.map((benefit, index) => (
    //         <div
    //           key={index}
    //           className={`relative p-[2px] rounded-3xl bg-gradient-to-br ${benefit.color} ${benefit.shadow} hover:shadow-lg sm:hover:shadow-xl transition`}
    //         >
    //           <div className="bg-white rounded-3xl p-6 sm:p-8 h-full">
    //             <div className={`inline-block px-3 py-1 text-xs sm:text-sm rounded-full font-semibold mb-3 sm:mb-4 ${benefit.badge}`}>
    //               {benefit.subtitle}
    //             </div>

    //             <h3 className="text-xl sm:text-2xl font-extrabold text-gray-900 mb-1 sm:mb-2">{benefit.title}</h3>
    //             <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">{benefit.description}</p>

    //             <ul className="space-y-3 sm:space-y-4 border-l-4 border-teal-400 pl-4 sm:pl-6 flex-grow">
    //               {benefit.points.map((point, idx) => (
    //                 <li key={idx} className="flex items-start gap-2 sm:gap-3">
    //                   <span className="mt-0.5 sm:mt-1 text-base sm:text-xl">{point.icon}</span>
    //                   <p className="text-gray-800 text-sm sm:text-base">{point.text}</p>
    //                 </li>
    //               ))}
    //             </ul>
    //           </div>
    //         </div>
    //       ))}
    //     </div> */}

    // {/* <div className="bg-blue-50  pb-6 sm:pb-8 px-4 sm:px-6 md:px-10 mt-8 sm:mt-10">
    //       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 md:gap-x-20 gap-y-8 sm:gap-y-12 items-start">

    //         <div className="space-y-6 sm:space-y-12">
    //           <h2 className="text-2xl sm:text-4xl font-extrabold text-purple-800">
    //             Opportunity Class(OC) Journey (Year 3 & 4)
    //           </h2>
    //           <p className="text-base sm:text-lg text-gray-700 max-w-2xl">
    //             This program is for kids who are in Year 3 or 4. Whether you are about to start the OC Journey (in Year 3) OR if you have filled up the form and working towards exam preparation (Year 4) this offering is for you to consider about your child.
    //           </p>

    //           <div className="p-4 sm:p-6 mb-6 sm:mb-10 rounded-xl sm:rounded-2xl bg-gradient-to-r from-green-100 via-green-50 to-green-100 shadow-md sm:shadow-lg border-l-4 sm:border-l-8 border-green-400 space-y-2 sm:space-y-3">
    //             <h4 className="text-xl sm:text-2xl font-semibold text-green-700">Weekly Mock Tests</h4>
    //             <p className="text-sm sm:text-base text-gray-800">
    //               Designed to simulate real exam conditions including Reading, Maths, and Thinking Skills.
    //             </p>
    //           </div>

    //           <div className="mt-12 sm:mt-24 p-4 sm:p-6 rounded-xl sm:rounded-2xl bg-gradient-to-r from-purple-100 via-purple-50 to-purple-100 shadow-md sm:shadow-lg border-l-4 sm:border-l-8 border-purple-400 space-y-2 sm:space-y-3">
    //             <h4 className="text-xl sm:text-2xl font-semibold text-purple-700">Pricing</h4>
    //             <p className="text-sm sm:text-base text-gray-800">
    //               Each mock test: <span className="font-bold text-purple-800">$45</span><br />
    //               Bundle of 10: <span className="font-bold text-purple-800">$400</span>
    //             </p>
    //           </div>
    //         </div>


    //         <div className="flex flex-col items-center space-y-4 sm:space-y-6">
    //           <img
    //             src={OCJouney}
    //             alt="Journey Visual"
    //             className="w-full max-w-md sm:max-w-xl h-auto rounded-xl sm:rounded-3xl shadow-lg sm:shadow-2xl object-contain"
    //           />


    //           <div className="w-full p-4 sm:p-6 rounded-xl sm:rounded-2xl bg-gradient-to-r from-yellow-100 via-yellow-50 to-yellow-100 shadow-md sm:shadow-lg border-l-4 sm:border-l-8 border-yellow-400 space-y-2 sm:space-y-3">
    //             <h4 className="text-xl sm:text-2xl font-semibold text-yellow-700">Practice Questions</h4>
    //             <p className="text-sm sm:text-base text-gray-800">
    //               Helps children build skills through mock tests and skill belts—from white to black in Maths.
    //             </p>
    //             <ul className="list-disc pl-4 sm:pl-5 text-gray-700 text-xs sm:text-sm space-y-1">
    //               <li>Maths – <span className="font-bold text-green-600">$109</span></li>
    //               <li>Reading – <span className="italic text-gray-500">Coming soon</span></li>
    //               <li>Thinking Skills – <span className="italic text-gray-500">Coming soon</span></li>
    //             </ul>
    //           </div>
    //         </div>
    //       </div>
    //     </div>

    //     <div className="mt-6 text-center">
    //       <Link to="/exam-selection">
    //         <button className="bg-yellow-400 hover:bg-orange-500 text-white font-semibold text-base sm:text-lg px-6 sm:px-10 py-3 sm:py-4 rounded-full shadow-md sm:shadow-lg transition duration-300">
    //           Start Assessment
    //           <i className="fas fa-arrow-right ml-2"></i>
    //         </button>
    //       </Link>
    //     </div> */}
    //   // </div>
  );
}